import { render, staticRenderFns } from "./TranslatorAssignment.vue?vue&type=template&id=e3267126&"
import script from "./TranslatorAssignment.vue?vue&type=script&lang=js&"
export * from "./TranslatorAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports